import Call from '../Call';
import {objToQs} from '../Utils';

const AdkPartnerBlock = {
    get(filters) {
        return Call(`adkPartnerBlock?${objToQs(filters)}`);
    },

    save(partner, subids) {
        return Call(`adkPartnerBlock/${partner}`,'POST', { subids });
    },

    remove(id) {
        return Call(`adkPartnerBlock/${id}`,'DELETE');
    }
}

export default AdkPartnerBlock;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkPartnerBlock.js